var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-vote" },
    [
      _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _vm.isTwoOption
        ? _c("div", { staticClass: "two-options" }, [
            !_vm.isVoted && !_vm.isFinish
              ? _c(
                  "div",
                  { staticClass: "two-un-voted" },
                  _vm._l(_vm.options, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "option",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.goToVote(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFinish || _vm.isVoted
              ? _c("div", { staticClass: "two-finished" }, [
                  _c("div", { staticClass: "option-name" }, [
                    _c(
                      "div",
                      {
                        staticClass: "left-c",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.goToVote(_vm.options[0])
                          },
                        },
                      },
                      [
                        _vm.userOptionId == _vm.options[0].id
                          ? _c("div", { class: _vm.getSelectedIconClass(0) })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "left-name",
                            style: { color: _vm.isFinish ? "#999" : "#4A70FF" },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.options[0].name) +
                                " " +
                                _vm._s(_vm.options[0].percent) +
                                "%\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "right-c",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.goToVote(_vm.options[1])
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "right-name",
                            style: { color: _vm.isFinish ? "#CCC" : "#FF5E4D" },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.options[1] && _vm.options[1].name) +
                                " " +
                                _vm._s(_vm.options[1].percent) +
                                "%\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.userOptionId == _vm.options[1].id
                          ? _c("div", { class: _vm.getSelectedIconClass(1) })
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "result-bar",
                    style: _vm.getBarStyle(),
                  }),
                ])
              : _vm._e(),
          ])
        : _c(
            "div",
            { staticClass: "mul-options" },
            _vm._l(_vm.options, function (item) {
              return _c("div", { key: item.id }, [
                !_vm.isVoted && !_vm.isFinish
                  ? _c(
                      "div",
                      {
                        staticClass: "vote-1",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.goToVote(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  : _c(
                      "div",
                      {
                        class: [
                          _vm.isFinish
                            ? "vote-3"
                            : _vm.userOptionId == item.id
                            ? "vote-2"
                            : "vote-3",
                        ],
                        style: { "--percent": item.percent + "%" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.goToVote(item)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "left-c" }, [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _vm._v(" "),
                          _vm.userOptionId == item.id
                            ? _c("div", { class: _vm.getSelectedIconClass(0) })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "percent" }, [
                          _vm._v(_vm._s(item.percent) + "%"),
                        ]),
                      ]
                    ),
              ])
            })
          ),
      _vm._v(" "),
      _c("Tips", { attrs: { fields: _vm.fields, isFinish: _vm.isFinish } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }